import React, { useState } from "react";
import algo from "../assets/network.gif";
import Modal from "../utils/Modal";
import { ReactComponent as Sensei } from "../assets/sensei/vault.svg";

function Algo() {
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [isVideoStarted, setIsVideoStarted] = useState(false);
  return (
    <section>
      <div className="max-w-6xl mx-auto px-10 sm:px-6">
        <div className="pt-12 border-t border-gray-800">
          {/* Items */}
          <div className="flex flex-col justify-center items-center">
            <div
              className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-6 mb-0 md:rtl flex flex-col justify-center items-center"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              {/* <ZenKarma className="md:w-96 w-80 md:px-0 px-14" /> */}
              <img
                className="mb-6 md:w-1/2 w-full"
                src={algo}
                alt="algorithm"
              />
            </div>
            {/* Item */}
            {/* <div className="md:grid md:grid-cols-12 md:gap-6 flex flex-col justify-center items-center">
       
              <div
                className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-6 mb-0 md:rtl flex flex-col justify-center items-center"
                data-aos="fade-up"
                data-aos-delay="200"
              >
  
                <img className="mb-6" src={algo} alt="algorithm" />
              </div>


              <div
                className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-6"
                data-aos="fade-up"
              >
                <div
                  className="text-xxl h1 mb-8 text-white md:text-left text-center"
                  data-aos="fade-up"
                >
                  Unlock an Algorithm Powered by Digital Generosity
                </div>
                <div
                  className="md:text-3xl text-2xl text-white md:text-left text-center mb-10 md:mb-28"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  Our unique vault algorithm grows stronger with user activity.
                  Small acts of{" "}
                  <span className="font-barlow font-semibold italic text-primary-1 mr-2">
                    {" digital generosity "}
                  </span>{" "}
                  create ripple effects benefiting the entire community.
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Algo;
